"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ChatSupportTrigger } from "@/components/chat-support-trigger";
import { toast } from "@/lib/components/use-toast";
import type { ChatSupport as ChatSupportComponent } from "@/components/chat-support";
const loadChatSupport = () => import("@/components/chat-support").then(mod => mod.ChatSupport);
export function ChatSupportLauncher() {
  const $ = _c(7);
  const [ChatSupport, setChatSupport] = useState(null);
  const [loading, setLoading] = useState(false);
  const prefetch = _temp2;
  let t0;
  if ($[0] !== loading) {
    t0 = () => {
      if (loading) {
        return;
      }
      setLoading(true);
      loadChatSupport().then(component => setChatSupport(() => component)).catch(_temp3).finally(() => setLoading(false));
    };
    $[0] = loading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const open = t0;
  if (ChatSupport) {
    let t1;
    if ($[2] !== ChatSupport) {
      t1 = <ChatSupport defaultOpen={true} />;
      $[2] = ChatSupport;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== loading || $[5] !== open) {
    t1 = <ChatSupportTrigger isOpen={false} hasUnread={false} aria-busy={loading} onClick={open} onPointerEnter={prefetch} onFocus={prefetch} />;
    $[4] = loading;
    $[5] = open;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function _temp3(error_0) {
  console.error("Failed to load chat support:", error_0);
  toast({
    title: "Chat support failed to load. Please try again.",
    variant: "destructive"
  });
}
function _temp2() {
  loadChatSupport().catch(_temp);
}
function _temp(error) {
  console.error("Failed to prefetch chat support:", error);
}